import 'core-js/stable';
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createI18n } from 'vue-i18n';
import '@/assets/styles/global.less' // 引入全局样式
import '@/assets/font_icon/iconfont.js';

// 引入 Ant Design Vue
import 'ant-design-vue/dist/antd.less';
import Antd from 'ant-design-vue';
// 1. 准备国际化消息
import { locales } from './config/i18n';
// 2. 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: 'zh', // 设置默认语言
  fallbackLocale: 'zh', // 设置回退语言
  globalInjection: true, // 全局注入 $t 函数
  messages: {
    en: locales.en,
    zh: locales.zh,
  },
});
// 3. 创建路由实例---在路由文件中
// 4. 创建 Vue 应用
const app = createApp(App);

// 5. 从URL获取语言参数并设置
const urlParams = new URLSearchParams(window.location.search)
const langParam = urlParams.get('lang')

if (langParam && Object.keys(i18n.global.messages.value).includes(langParam)) {
  i18n.global.locale.value = langParam;
}

// 6. 添加路由导航守卫处理语言切换
router.beforeEach((to) => {
  if (to.query.lang && to.query.lang !== i18n.global.locale.value) {
    if (Object.keys(i18n.global.messages.value).includes(to.query.lang)) {
      i18n.global.locale.value = to.query.lang
    }
  }
})
// 7. 使用插件
app.use(router);
app.use(i18n);
app.use(Antd, {
  locale: locales[i18n.global.locale.value].antd,
  message: {
    placement: 'bottomRight', // 关键配置
    duration: 5,       // 默认自动关闭延时，单位秒
    maxCount: 5,  
  }
})
// 8. 挂载应用
app.mount('#app');